<template>
  <div>
    <!--to-top-->
    <!--    <div class="to-top"><img src="/static/img/home/meeting2023.png"/></div>-->
    <!--首页弹窗-->
    <!--    <div class="index-pop-mask"></div>-->
    <!--    <div class="index-pop-pic">-->
    <!--      <div class="close-btn"></div>-->

    <!--    </div>-->
    <el-dialog
      class="home-dialog"
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose"
    >
      <img src="/static/img/gif/img.png" />
    </el-dialog>

    <div class="banner">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="slide-img">
              <img src="/static/img/banner1.png" />
            </div>
          </div>
          <div class="swiper-slide">
            <div @click="goPush()" class="slide-img">
              <img src="/static/img/banner.png" alt="" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="slide-img">
              <img src="/static/img/home/last.png" />
            </div>
          </div>

          <!--          <div class="swiper-slide">-->
          <!--            <div class="slide-img">-->
          <!--              <img src="/static/img/banner1.png">-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <div class="index">
      <div class="sql-login">
        <div class="wrap">
          <div class="login-bg">
            <div class="title wow fadeInDown">
              <img src="/static/img/login-tit.png" class="pc-login-tit" />
              <img src="/static/img/m-login-tit.png" class="m-login-tit" />
            </div>
            <div class="sql-con">
              <div
                @mouseleave="leave(item.key)"
                @mouseenter="enter(item.key)"
                @click="goPages(item.src)"
                class="sql-con-row"
                v-for="item in dataLog"
                :key="item.key"
              >
                <img
                  :class="dataLogKey === item.key ? 'trs' : 'sql-con-row-img'"
                  class="sql-con-row-img"
                  :src="item.img"
                  alt=""
                />

                <span
                  :class="
                    dataLogKey === item.key
                      ? 'sql-con-row-text-yes'
                      : 'sql-con-row-text'
                  "
                >
                  {{ item.title }}
                </span>
              </div>
            </div>
          </div>
          <div class="advant wow fadeInUp">
            <div class="ad-item item01">
              <h3>
                <ICountUp
                  :delay="delay"
                  :endVal="34521600"
                  :options="options"
                />
              </h3>
              <p>总字段元填写量</p>
            </div>
            <div class="ad-item item02">
              <h3>
                <ICountUp :delay="delay" :endVal="53940" :options="options" />
                <span class="item-dw">例</span>
              </h3>
              <p>总数据量</p>
            </div>
            <div class="ad-item item03">
              <h3>
                <ICountUp :delay="delay" :endVal="110" :options="options" />
                <span class="item-dw">例</span>
              </h3>
              <p>月增加量</p>
            </div>
            <div class="ad-item item04">
              <h3>
                <ICountUp :delay="delay" :endVal="242" :options="options" />
                <span class="item-dw">位</span>
              </h3>
              <p>注册用户量</p>
            </div>
            <div class="ad-item item05">
              <h3>
                <ICountUp :delay="delay" :endVal="134" :options="options" />
                <span class="item-dw">家</span>
              </h3>
              <p>注册中心量</p>
            </div>
          </div>
          <div class="produce">
            <div class="index-tit">
              <h4 class="wow fadeInDown">平台介绍</h4>
              <h5 class="wow fadeInLeft">INTORDUCTION TO THE PLATFORM</h5>
            </div>
            <div class="pro-text wow fadeInRight">
              <p>
                为了推动跨地区数据平台建设，为我国减重代谢外科发展提供循证依据，并推进学科质量控制和有序健康发展<br />
                “大华北减重与代谢外科联盟”于2017年11月成立，并搭建完成“大华北减重与代谢手术临床资料数据库”<br />
                发布了首部年度数据登记报告——《大华北减重与代谢手术临床资料数据库年度报告（2018）》。2019年3月<br />
                数据库完成首次升级改版，且参与数据登记地区范围持续扩大，截至2019年12月，共开设中心账号52家，覆盖21个省市<br />
                自治区及直辖市。2020年5月，数据库发布了第2版《大华北减重与代谢手术临床资料数据库
                2019年度报告》<br />
                并正式升级为“大中华减重与代谢手术数据库”，希望通过全国性减重与代谢外科数据平台的搭建和持续优化<br />
                能够为我国减重代谢手术发展现状与趋势提供数据依据，助力我国减重代谢外科不断向前发展。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="ideas wrap">
        <div class="index-tit">
          <h4 class="wow fadeInDown">发展理念</h4>
          <h5 class="wow fadeInLeft">DEVELOPMENT CONCEPT</h5>
        </div>
        <div class="ideas-con">
          <div class="con-item">
            <div class="item-pic"><img src="/static/img/ln.png" /></div>
            <div class="item-text">
              <h3>手术规范</h3>
              <p>Standard</p>
            </div>
          </div>
          <div class="con-item">
            <div class="item-pic"><img src="/static/img/ln01.png" /></div>
            <div class="item-text">
              <h3>技术推广</h3>
              <p>Spread</p>
            </div>
          </div>
          <div class="con-item">
            <div class="item-pic"><img src="/static/img/ln02.png" /></div>
            <div class="item-text">
              <h3>科学研究</h3>
              <p>Science</p>
            </div>
          </div>
        </div>
      </div>
      <div class="video-main">
        <div class="video-con">
          <div class="lImg vidContent wow fadeInLeft">
            <video
              src="https://c-mbs.oss-cn-beijing.aliyuncs.com/Video/2018ncbmd.mp4"
              loop="loop"
              controls="controls"
            >
              您的浏览器暂时不支持video标签
            </video>
          </div>
          <div class="rText wow fadeInRight">
            2018年度减重与代谢手术数据报告
          </div>
        </div>
      </div>
      <div class="video-main video-bg1">
        <div class="video-con">
          <div class="rText wow fadeInRight">
            2019年度减重与代谢手术数据报告
          </div>
          <div class="lImg vidContent wow fadeInLeft">
            <video
              src="https://c-mbs.oss-cn-beijing.aliyuncs.com/Video/2019.mp4"
              loop="loop"
              controls="controls"
            >
              您的浏览器暂时不支持video标签
            </video>
          </div>
        </div>
      </div>
      <div class="video-main">
        <div class="video-con">
          <div class="lImg vidContent wow fadeInLeft">
            <video
              src="https://c-mbs.oss-cn-beijing.aliyuncs.com/Video/2021.mp4"
              loop="loop"
              controls="controls"
            >
              您的浏览器暂时不支持video标签
            </video>
          </div>

          <div class="rText wow fadeInRight">2021年度大中华减重数据发布</div>
        </div>
      </div>
      <div class="video-main video-bg1">
        <div class="video-con">
          <div class="rText wow fadeInRight">
            2023年减重与代谢手术区块链平台发布
          </div>
          <div class="lImg vidContent wow fadeInLeft">
            <video
              src="https://c-mbs.oss-cn-beijing.aliyuncs.com/Video/2023.mp4"
              loop="loop"
              controls="controls"
            >
              您的浏览器暂时不支持video标签
            </video>
          </div>
        </div>
      </div>

      <div class="data-view wrap">
        <div class="index-tit">
          <h4 class="wow fadeInDown">中国减重与代谢手术数据报告1</h4>
          <h5 class="wow fadeInDown">REGISTRY REPORT</h5>
        </div>
        <div class="view-con">
          <a
            target="_blank"
            href="https://c-mbs.oss-cn-beijing.aliyuncs.com/webapp/2019pdf2.pdf"
          >
            <div class="view-item wow fadeInRight">
              <div class="item-pic">
                <img src="/static/img/home/74321620975849_.pic_hd.png" />
              </div>
              <p>大华北减重与代谢外科手术临床资料数据库（2019年报）</p>
            </div>
          </a>

          <a
            target="_blank"
            href="https://c-mbs.oss-cn-beijing.aliyuncs.com/webapp/2020pdf.pdf"
          >
            <div class="view-item wow fadeInRight">
              <div class="item-pic"><img src="/static/img/home/to3.png" /></div>
              <p>大中华减重与代谢外科手术临床资料数据库（2020年报）</p>
            </div>
          </a>

          <a
            target="_blank"
            href="https://c-mbs.oss-cn-beijing.aliyuncs.com/webapp/2021pdf.pdf"
          >
            <div class="view-item wow fadeInRight">
              <div class="item-pic"><img src="/static/img/home/to4.png" /></div>
              <p>大中华减重与代谢外科手术临床资料数据库（2021年报）</p>
            </div>
          </a>

          <a
            target="_blank"
            href="https://c-mbs.oss-cn-beijing.aliyuncs.com/webapp/2022.pdf"
          >
            <div class="view-item wow fadeInRight">
              <div class="item-pic">
                <img src="/static/img/home/top5.png" />
              </div>
              <p>大中华减重与代谢外科手术临床资料数据库（2022年报）</p>
            </div>
          </a>

          <a
            target="_blank"
            href="https://c-mbs.oss-cn-beijing.aliyuncs.com/2023pdf"
          >
            <div class="view-item wow fadeInRight">
              <div class="item-pic">
                <img src="/static/img/home/top6.png" />
              </div>
              <p>大中华减重与代谢外科手术临床资料数据库（2023年报）</p>
            </div>
          </a>

          <a
            target="_blank"
            href="https://c-mbs.oss-cn-beijing.aliyuncs.com/webapp/2024.pdf"
          >
            <div class="view-item wow fadeInRight">
              <div class="item-pic">
                <img src="/static/img/home/top7.png" />
              </div>
              <p>大中华减重与代谢外科手术临床资料数据库（2024年报）</p>
            </div>
          </a>
          <a
            target="_blank"
            href="https://c-mbs.oss-cn-beijing.aliyuncs.com/webapp/2025.pdf"
          >
            <div class="view-item wow fadeInRight">
              <div class="item-pic">
                <img src="/static/img/home/top8.png" />
              </div>
              <p>大中华减重与代谢外科手术临床资料数据库（2025年报）</p>
            </div>
          </a>
        </div>
      </div>

      <div class="data-view wrap">
        <div class="index-tit">
          <h4 class="wow fadeInDown">历年数据年报-优秀科技论文证书</h4>
          <h5 class="wow fadeInDown">HONORED EXCELLENT CERTIFICATE</h5>
        </div>
        <div class="view-con">
          <div class="view-item wow fadeInRight">
            <div class="item-pic">
              <img src="/static/img/home/youxiu.jpg" />
            </div>
          </div>

          <div class="view-item wow fadeInRight">
            <div class="item-pic">
              <img src="/static/img/home/youxiu4.png" />
            </div>
          </div>

          <div class="view-item wow fadeInRight">
            <div class="item-pic">
              <img src="/static/img/home/2020lp.png" />
            </div>
          </div>

          <div class="view-item wow fadeInRight">
            <div class="item-pic">
              <img src="/static/img/home/2021lp.png" />
            </div>
          </div>
        </div>
        <div class="view-con">
          <div class="view-item wow fadeInRight">
            <div class="item-pic">
              <img src="/static/img/home/youxiu2.jpg" />
            </div>
          </div>

          <div class="view-item wow fadeInRight">
            <div class="item-pic">
              <img src="/static/img/home/youxiu3.jpg" />
            </div>
          </div>
          <div class="view-item wow fadeInRight">
            <div class="item-pic">
              <img src="/static/img/home/youxiu5.png" />
            </div>
          </div>
          <div class="view-item wow fadeInRight">
            <div class="item-pic">
              <img src="/static/img/home/youxiu6.png" />
            </div>
          </div>
        </div>
      </div>

      <div class="classic-introduction">
        <div class="wrap">
          <div class="index-tit">
            <h4 class="wow fadeInDown">经典术式介绍</h4>
            <h5 class="wow fadeInDown">CLASSIC SURGERY INTRODUCTION</h5>
          </div>
          <div class="classic-con">
            <div class="classic-nav wow fadeInLeft">
              <div :class="videoState === 'SG' ? 'active' : ''" class="tab-nav">
                <a @click="switchVideo('SG')" href="javascript:;"
                  >腹腔镜胃袖状切除术（SG）</a
                >
              </div>
              <div
                :class="videoState === 'RYGB' ? 'active' : ''"
                class="tab-nav"
              >
                <a @click="switchVideo('RYGB')" href="javascript:;"
                  >腹腔镜Roux-en-Y旁路术（RYGB）</a
                >
              </div>
              <div
                :class="videoState === 'OAGB' ? 'active' : ''"
                class="tab-nav"
              >
                <a @click="switchVideo('OAGB')" href="javascript:;"
                  >腹腔镜单吻合口胃旁路术（OAGB）</a
                >
              </div>
            </div>
            <div v-if="videoState === 'SG'" class="cls-content ">
              <video
                poster="/static/img/home/SG.png"
                src="https://c-mbs.oss-cn-beijing.aliyuncs.com/Video/SG.mp4"
                class=""
                loop="loop"
                controls="controls"
              >
                您的浏览器暂时不支持video标签
              </video>
              <!--              <div class="cls-title">腹腔镜胃袖状切除术（SG）</div>-->
            </div>

            <div v-if="videoState === 'RYGB'" class="cls-content ">
              <video
                src="https://c-mbs.oss-cn-beijing.aliyuncs.com/Video/OAGB-2.mp4"
                class=""
                poster="/static/img/home/RYGB.png"
                loop="loop"
                controls="controls"
              >
                您的浏览器暂时不支持video标签
              </video>
              <!--              <div class="cls-title">腹腔镜Roux-en-Y旁路术（RYGB）</div>-->
            </div>
            <div v-if="videoState === 'OAGB'" class="cls-content">
              <video
                src="https://c-mbs.oss-cn-beijing.aliyuncs.com/Video/RYGB-2.mp4"
                class=""
                poster="/static/img/home/OAGB.png"
                loop="loop"
                controls="controls"
              >
                您的浏览器暂时不支持video标签
              </video>
              <!--              <div class="cls-title">腹腔镜单吻合口胃旁路术（OAGB）</div>-->
            </div>
          </div>
        </div>
      </div>

      <div class="bim-box">
        <div class="wrap">
          <div class="index-tit">
            <h4 class="wow fadeInDown">BMI计算器</h4>
            <h5 class="wow fadeInDown">BMI CALCULATOR</h5>
          </div>
          <div class="bim-count">
            <input
              v-model="kg"
              type="text"
              placeholder="请输入体重(kg)"
              class="higher-num"
            />
            <span><img src="/static/img/c.png"/></span>
            <div class="weight-box">
              <input
                v-model="m"
                type="text"
                placeholder="请输入身高(m)"
                class="weight-num"
              />
              <em>2</em>
            </div>
            <span><img src="/static/img/d.png"/></span>
            <input v-model="bmi" type="text" disabled class="weight-num" />

            <a @click="count" href="javascript:;" class="count-btn">点击计算</a>
          </div>
          <div class="bim-con">
            <h5 class="wow fadeInDown">
              肥胖疾病世界卫生组织（WHO）诊断标准及中国减重与代谢手术BMI指征
            </h5>
            <p class="wow fadeInDown">
              criteria for obesity and Bariatric surgery according to the World
              Health Organization (WHO) and guideline in China
            </p>
            <div class="table-con">
              <div class="left-pic wow fadeInLeft">
                <img src="/static/img/bim-pic01.png" />
              </div>
              <img src="/static/img/bmi-table.png" />
              <div class="right-pic wow fadeInRight">
                <img src="/static/img/bim-pic.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="wrap">
        <a href="#" class="f-logo wow fadeInLeft"
          ><img src="/static/img/f-logo.png"
        /></a>
        <!--			<p class="wow fadeInRight">地址：北京丰台区汉威广场二区1号楼6M层</p>-->

        <p class="wow fadeInRight">
          Copyright © 2017-2020 大中华减重与代谢外科数据平台京ICP备17044059号
        </p>
        <p>
          平台支持：<a target="_blank" href="http://www.edocdata.com/"
            >北京易得医数科技有限责任公司</a
          >
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
require("../../static/js/jquery.waypoints.min.js");
require("../../static/js/common.js");
require("../../static/js/swiper.min.js");
require("../../static/js/index.js");
require("../../static/laydate/laydate.js");
import VueCountUp from "vue-countupjs";
import ICountUp from "vue-countup-v2";

export default {
  components: { VueCountUp, ICountUp },
  data() {
    return {
      videoState: "SG",
      kg: null,
      m: null,
      bmi: null,
      dialogVisible: false,
      delay: 3000,
      options: {
        useEasing: true,
        useGrouping: true,
        duration: 30,
        separator: ",",
        decimal: ".",
        prefix: "",
        suffix: ""
      },
      dataLog: [
        {
          title: "大中华减重与代谢手术数据库",
          img: "/static/img/login-pic.png",
          key: 1,
          src: "https://c-mbsdata.com/"
        },
        {
          title: "胃袖状切除术联合玛仕度肽辅助治疗重度肥胖症:一项多中心、随机、对照、双盲、优效性临床研究",
          img: "/static/img/ima2.png",
          key: 2,
          src: "https://smartrial-edc.com/user/login"
        },
        {
          title:
            "减重与代谢手术治疗非酒精性脂肪性肝病/非酒精性脂肪性肝炎前瞻性、多中心临床研究数据采集平台",
          img: "/static/img/login-pic01.png",
          key: 3,
          src: "https://nash.edocdata.com/crc/user/login"
        },
        {
          title: "胃袖状切除术术后胃漏病例数据库",
          img: "/static/img/login-pic02.jpg",
          key: 4,
          src: "https://sgleak.c-mbs.com/next/welcome"
        },
        {
          title:
            "单吻合口与Roux-en-Y胃旁路术治疗 2 型糖尿病多中心、随机对照、优效性临床研究",
          img: "/static/img/order.png",
          key: 5,
          src: "https://order-trial.com"
        },
        {
          title: "减重与代谢外科质量控制病例登记平台",
          img: "/static/img/home/bj.png",
          key: 6,
          src: "https://c-mbsdata.com/control"
        },
        {
          title: "减重与代谢外科质量控制基准研究",
          img: "/static/img/home/t6.png",
          key: 7,
          src: "https://dbbs.edocdata.com/crc/"
        }
      ],
      dataLogKey: null
    };
  },
  methods: {
    goPages(src) {
      if (!src) return;
      window.open(src);
    },
    leave() {
      this.dataLogKey = "";
    },
    enter(key) {
      this.dataLogKey = key;
    },
    switchVideo(state) {
      // if(state === 'RYGB'){
      //   console.log(this.$refs.OAGB);
      //
      //   // this.$refs.OAGB.pause()
      //   // this.$refs.SG.pause()
      // }else if(state === 'OAGB'){
      //   // this.$refs.RYGB.pause()
      //   // this.$refs.SG.pause()
      // }else if(state === 'SG'){
      //   // this.$refs.RYGB.pause()
      //   // this.$refs.OAGB.pause()
      // }

      this.videoState = state;
    },
    count() {
      this.bmi = (this.kg / (this.m * this.m)).toFixed(2);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    onReady: function(instance, CountUp) {
      const that = this;
      instance.update(that.endVal + 100);
    },
    goPush() {
      window.open("http://ebmica.com/");
    }
  },
  mounted() {
    this.dialogVisible = false; // 打开弹出框
  }
};
</script>

<style scoped>
@import url("../../static/css/swiper.min.css");
@import url("../../static/css/common.css");
@import url("../../static/css/index.css");
@import url("../../static/css/respond.css");
</style>



// WEBPACK FOOTER //
// src/views/index.vue